var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7562_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66739 6.66635V10.6664M4.66739 10.6664H8.66739M4.66739 10.6664L7.75406 7.75968C8.67365 6.83951 9.8674 6.24314 11.1554 6.06045C12.4434 5.87775 13.756 6.11863 14.8952 6.74678C16.0344 7.37493 16.9386 8.35632 17.4715 9.54306C18.0044 10.7298 18.1372 12.0576 17.8498 13.3264C17.5624 14.5952 16.8705 15.7362 15.8782 16.5775C14.886 17.4188 13.6471 17.9148 12.3485 17.9907C11.0498 18.0667 9.76156 17.7185 8.67796 16.9987C7.59436 16.2788 6.77408 15.2263 6.34073 13.9997",
    stroke: "#2b60f6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7562_5179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoEdit);
export default __webpack_public_path__ + "static/media/undoEdit.95ffcf0e9385717174b913b75ebaadaa.svg";
export { ForwardRef as ReactComponent };